// extracted by mini-css-extract-plugin
module.exports = {"tutorial":"Tutorial_tutorial__30fgF","image":"Tutorial_image__1Ou0A","spin":"Tutorial_spin__3xMYn","transition-opacity":"Tutorial_transition-opacity__1ts8R"};